import t from "./ghl-ui.es1207.js";
var e = t(Object.getPrototypeOf, Object);
const r = e;
export {
  r as default
};
